window.$ = window.jQuery = require("jquery");

require("slick-carousel");

require("./intlTelInput");
require("./intlTelInputLocal");
require("./faq");
require("./channel");
require("./career");
require("./homepage");
require("./products");
require("./tariffs");
require("./series");
require("./movies");
require("./tv-tariffs");
require("./terms-pages");
require("./tariff-add-ons");
require("./footer");
require("./header");
require("./apn");
require("./poslovnice");
require("./about-us");
require("./top-actions");
require("./addition");
require("./prepaid");
require("./roaming");
require("./tariff-add");
require("./sim-registration");
require("./single-phone-section");
require("./esim");
require("./tariff-new");
require("./checkout-redesign");
// require("./snowflakes");
